import "./polyfills";
import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./app";

window.smuEmbedFinancialWellbeingInteractive = function (element, interactive) {
    const el = element instanceof HTMLElement ? element : document.querySelector(element);
    ReactDOM.render(
        <React.StrictMode>
            <div className={"smuFinancialWellbeingEmbed"}>
                <App interactive={interactive} />
            </div>
        </React.StrictMode>,
        el
    );
};
